/*
 * Panneau de recherche par defaut : produits vus recemment.
 * Stockage local uniquement — rien n'est envoye au serveur.
 */
(function () {
  const KEY = 'rma:recently-viewed';
  const MAX = 8;

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // navigation privee, stockage bloque : on degrade sans casser la recherche
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* ignore */
    }
  }

  // Appele depuis la fiche produit
  window.rmaRecordProductView = function (item) {
    if (!item || !item.handle) return;
    const list = read().filter((x) => x.handle !== item.handle);
    list.unshift(item);
    write(list);
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('RmaSearchDefault', () => ({
      recent: [],
      load() {
        this.recent = read();
      },
      clear() {
        write([]);
        this.recent = [];
      },
    }));
  });
})();
